export const userTableColumns = [
	{
		id: 'username',
		label: 'User Name',
	},
	{
		id: 'role',
		label: 'Role',
	},
	{
		id: 'email',
		label: 'Email',
	},
	{
		id: 'phoneNumber',
		label: 'Phone Number',
	},
	{
		id: 'options',
		label: 'Options',
	},
];
